document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-new-arrivals]').forEach(function(section) {
    const activeColor = section.dataset.swatchActiveColor;
    const quickAddText = section.dataset.quickAddText;
    const addedText = section.dataset.addedText;

    // 1. Swatch Click Logic
    section.querySelectorAll('.nr-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = this.closest('.nr-card-wrapper');
        const image = wrapper.querySelector('.nr-image');
        const card = wrapper.querySelector('.nr-card');
        const quickBtn = wrapper.querySelector('.nr-quick-add-btn');
        
        const newImageUrl = this.getAttribute('data-image-url');
        const newImageSrcset = this.getAttribute('data-image-srcset');
        const variantId = this.getAttribute('data-variant-id');
        const baseUrl = card.getAttribute('href').split('?')[0];

        const activeStyle = `outline: 2px solid ${activeColor} !important; outline-offset: 3px !important; transform: scale(1.15) !important;`;
        const normalStyle = `outline: 2px solid transparent !important; outline-offset: 3px !important; transform: scale(1) !important;`;
        
        wrapper.querySelectorAll('.nr-swatch').forEach(function(s) {
          s.style.cssText = normalStyle;
        });
        this.style.cssText = activeStyle;

        if (image && newImageUrl) {
          image.removeAttribute('srcset');
          image.src = newImageUrl;
          if (newImageSrcset) {
            setTimeout(() => { image.srcset = newImageSrcset; }, 50);
          }
        }

        if (card && variantId) {
          card.href = baseUrl + '?variant=' + variantId;
        }

        if (quickBtn && variantId) {
          quickBtn.setAttribute('data-variant-id', variantId);
          quickBtn.textContent = quickAddText;
          quickBtn.disabled = false;
        }
      });
    });

    // 2. Add to Cart Logic (Fixed for Dawn)
    section.querySelectorAll('.nr-quick-add-btn').forEach(function(btn) {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();

        // FIX: Prevent duplicate clicks or duplicate listeners from running
        if (this.classList.contains('is-adding')) return;
        this.classList.add('is-adding');

        const variantId = parseInt(this.getAttribute('data-variant-id'));
        if (!variantId) {
          this.classList.remove('is-adding');
          return;
        }

        const originalText = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          const data = await response.json();

          if (response.ok && !data.status) {
            this.textContent = addedText;
            
            // Update Dawn's cart count bubble manually
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            bubbles.forEach(bubble => {
              if (cart.item_count > 0) {
                bubble.textContent = cart.item_count;
                bubble.classList.remove('hidden');
              } else {
                bubble.classList.add('hidden');
              }
            });

            // Trigger generic refresh event
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(() => { 
              this.textContent = originalText; 
              this.disabled = false; 
              this.classList.remove('is-adding');
            }, 2000);
          } else {
            alert(data.description || data.message || 'Could not add to cart');
            this.textContent = originalText;
            this.disabled = false;
            this.classList.remove('is-adding');
          }
        } catch (error) {
          console.error('Cart error:', error);
          this.textContent = originalText;
          this.disabled = false;
          this.classList.remove('is-adding');
        }
      });
    });
  });
});